export default __webpack_public_path__ + "static/media/3.a0402a7e.jpg";